<template>
<div v-if="vacationInfo != null">
  <div id="header" v-bind:class="[getColorHeader()]" style="height: 4px"></div>
  <v-container v-if="isApproveVacation" id="vacationContainer" style="width: 100%; height: 500px">
      <ApproveVacation v-on:backtoDetailScreen="backFromApprove" style="width: 100%; height: 500px" :VacationData ="{VacationData: copyVacatinInfo(), userInfomation: userInfomation, VacationDetail: VacationDetail}"></ApproveVacation>
  </v-container>

  <v-container v-else-if="isRejectVacation" id="vacationContainer" style="width: 100%;">
      <VacationReject v-on:backtoDetailScreen="backFromReject" style="width: 100%" :VacationData ="{VacationData: copyVacatinInfo(), userInfomation: userInfomation, VacationDetail: VacationDetail}"></VacationReject>
  </v-container>

  <v-container v-else id="vacationContainer" style="height: 100%;">
      <v-layout column>
          <div style="width: 100%" class="text-center avatarPos mb-2">
            <span  v-bind:class="[getColorStatus()]"  style="font-size: 14px; padding-left: 80px; font-weight: bold">{{getTextStatus()}}</span>
            <div style="width: 70px; float: right" class="pr-3 mr-3 mt-2">
              <v-avatar @click="closeDetail()" style="position: fixed" width="18px" height="18px">
                <img src="@/assets/close.png"/>
              </v-avatar>
            </div>
         </div>
        <v-flex id="flex1" d-flex>
            <header-vacation  :VacationData="{VacationData: vacationInfo, userInfomation: userInfomation}" id="headerVacation"></header-vacation>
        </v-flex>
        <v-flex id="flex2" d-flex>
            <content-vacation  class="pl-3" :VacationData="{VacationData: vacationInfo, VacationDetail: VacationDetail, userInfomation: userInfomation, approverInformation: approverInformation}" id="contentVacation"></content-vacation>
        </v-flex>
         <v-flex id="flex3" d-flex>
            <footer-vacation @showApproveScreen="isApproveVacation = true" @showRejectScreen="isRejectVacation = true" @showDeleteDialog="showDeleteDialog" class="pl-3" :VacationData="{VacationData: vacationInfo, VacationDetail: VacationDetail}" id="footerVacation"></footer-vacation>
        </v-flex>
      </v-layout>
  </v-container>
</div>
</template>

<script>
    import ApproveVacation from '../../components/vacations/VacationApprove'
    import VacationReject from '../../components/vacations/VacationReject'
    import HeaderVacation from '../../components/commonui/vacations/HeaderVacation'
    import ContentVacation from '../../components/commonui/vacations/ContentVacation'
    import FooterVacation from '../../components/commonui/vacations/FooterVacation'
    import { mapGetters, mapState } from "vuex";
    import { ListEvents, VacationStatus } from "@/utilities/CommonUtilities";
    export default {
        components: {HeaderVacation, ContentVacation,FooterVacation, ApproveVacation, VacationReject},
        props: ["vacationid"],
        data () {
            return {
                isApproveVacation: false,
                vacationInfo: null,
                VacationDetail:{},
                userInfomation: {},
                approverInformation: {},
                inprogressVacation: 'inprogressVacation',
                approvedVacation: 'approvedVacation',
                rejectedVacation: 'rejectedVacation',
                canceledVacation: 'canceledVacation',
                inprogressHeader: 'inprogressHeader',
                approvedHeader: 'approvedHeader',
                rejectedHeader: 'rejectedHeader',
                canceledHeader: 'canceledHeader',
                inprogressText: this.$i18n.t("vacations_inprogress"),
                approvedText: this.$i18n.t("vacations_approved"),
                rejectedText: this.$i18n.t("vacations_rejected"),
                canceledText: this.$i18n.t("vacations_past"),
                isRejectVacation: false,
                isDestroyed: false,
                log: "deleteVacation",
                headerColor:''
            }
        },
        computed: {
            ...mapState(["listUser", "token", "listReason"]),
            ...mapGetters({
                getVacationById: "homeData/getVacationById"
            }),
            ...mapGetters(["getUserByID"]),
            ...mapGetters(["getReasonByID"]),
        },
        async created(){
          this.notifyBus.$on(ListEvents.dialogSelectedAction, (value) => {
              if(value){
                this.deleteVacation();
              }
          });
          
          this.notifyBus.$emit(ListEvents.showLoadingIndicator);
          try{
            let params = {'token': this.token, 'id': this.vacationid};
            let responseVacationDetail = await this.dataSource.getData(this.dataSource.getVacation, params);
            this.VacationDetail = responseVacationDetail.data['vacation'];
            this.vacationInfo = this.getVacationById(this.vacationid);
            this.userInfomation = this.getUserByID(this.VacationDetail[0].user_id);
            this.approverInformation = this.getUserByID(this.VacationDetail[0].apply_uid)
          } catch(ex) {
            return;
          } finally {
            this.notifyBus.$emit(ListEvents.hideLoadingIndicator);
          }           
        },
        
        methods: {
          copyVacatinInfo() {
             let newVacation = {};
             Object.assign(newVacation, this.vacationInfo);
             return newVacation;
          },
           backFromApprove: function (value) {
               this.VacationDetail = value;
               this.userInfomation = this.getUserByID(this.VacationDetail[0].user_id);
               this.approverInformation = this.getUserByID(this.VacationDetail[0].apply_uid)
               this.isApproveVacation = false;
           },
           backFromReject: function (value) {
               this.VacationDetail = value;
               this.userInfomation = this.getUserByID(this.VacationDetail[0].user_id);
               this.approverInformation = this.getUserByID(this.VacationDetail[0].apply_uid)
               this.isRejectVacation = false;
           },
           getColorStatus(){
            if(this.VacationDetail[0] != null){
              if(this.VacationDetail[0].status == VacationStatus.InProgress){
               return this.inprogressVacation;
              }
             else if(this.VacationDetail[0].status == VacationStatus.Approved){
                return this.approvedVacation;
              }
             else if(this.VacationDetail[0].status == VacationStatus.Rejected){
                return this.rejectedVacation;
              }
              else {
               return this.canceledVacation;
              }
            }
            else {
               return this.canceledVacation;
              }
             
           },
           getColorHeader(){
            if(this.VacationDetail[0] != null){
              if(this.VacationDetail[0].status == VacationStatus.InProgress){
               return this.inprogressHeader;
              }
             else if(this.VacationDetail[0].status == VacationStatus.Approved){
                return this.approvedHeader;
              }
             else if(this.VacationDetail[0].status == VacationStatus.Rejected){
                return this.rejectedHeader;
              }
              else {
               return this.canceledHeader;
              }
            }
            else {
               return this.canceledHeader;
              }
             
           },
           getTextStatus(){
            if(this.VacationDetail[0] != null){
               if(this.VacationDetail[0].status == VacationStatus.InProgress){
                 return this.inprogressText;
              }
              else if(this.VacationDetail[0].status == VacationStatus.Approved){
                 return this.approvedText;
              }
              else if(this.VacationDetail[0].status == VacationStatus.Rejected){
                 return this.rejectedText;
              }
              else{
                return this.canceledText;
              }
            }else{
                return this.canceledText;
              }
           },
           
           closeDetail() {
              this.notifyBus.$emit(ListEvents.closeVacationDetail);
           },
           showDeleteDialog(){
              this.notifyBus.$emit(ListEvents.showYesNoDialog, this.$t("vacation_detail_confirm_delete")); 
           },
           async deleteVacation(){

             if(this.isDestroyed) return;
             this.notifyBus.$emit(ListEvents.showLoadingIndicator);
             try{
               let params = {'token': this.token, 'id': this.vacationid};
               await this.dataSource.postData(this.dataSource.deleteVacation, params);
               this.notifyBus.$emit(ListEvents.hideLoadingIndicator);
               this.notifyBus.$emit(ListEvents.closeVacationDetail);
               this.notifyBus.$emit(ListEvents.reloadAllTabs, true);
               this.notifyBus.$emit(ListEvents.showOKDialog, this.$t("vacation_detail_delete_success"));
            } catch(ex) {
              this.notifyBus.$emit(ListEvents.hideLoadingIndicator);
              this.notifyBus.$emit(ListEvents.showOKDialog, this.$i18n.t('common_unknown_error'));
              return;
            }
           },
          },
          beforeDestroy: function() {
            this.isDestroyed = true;
          },
        inject: ["dataSource", "notifyBus"],
    }
</script>
<style scoped>
   #header{
     position: -webkit-sticky;
  position: sticky;
  top: 0;
   }
   #headerVacation{
     height: 100%;
     width: 100%;
   }
   #contentVacation{
     height: 100%;
     width: 100%;
   }
   #flex3 {
     position: -webkit-sticky;
     position: sticky;
     bottom: 0;
     font-size: 20px;
    }
   #headerVacation{
     background-color: white;
   }
   #footerVacation {
     position: -webkit-sticky;
     position: sticky;
     bottom: 0;
     font-size: 20px;
     height: 100%;
     background-color: white;
     width: 100%;
     display: flex;
     align-items: center;
     justify-content: center;
  }
   #flex1{
     height: 220px;
  }
   #flex2{
     height: 285px;
   }
   #flex3{
    height: 86px
   }
   .inprogressVacation{
    color: #F1BD42;
   }
   .approvedVacation{
     color: #3FE090
   }
   .rejectedVacation{
     color: red
   }
   .canceledVacation{
     color: grey
   }
   .canceledHeader{
     background-color: grey
   }
   .approvedHeader{
     background-color: #3FE090
   }
   .rejectedHeader{
     background-color: red
   }
   .inprogressHeader{
     background-color: #F1BD42;
   }
</style>
